import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import FormControl from 'react-bootstrap/FormControl'
import { useLazyQuery } from '@apollo/react-hooks'

import { loaderAlert, simpleAlert } from '../../../common'
import { salmon } from '../../../styles/themeColors'
import { SiteLogo } from '../../../components/customIcons'
import { GET_MAGIC_LINK } from '../../../graphql/publicQueries'

export const GetMagicLink: React.FC<{
  open: boolean
  closeModal: () => void
  event: string
}> = ({ open, closeModal, event }) => {
  const [getLink, { loading }] = useLazyQuery(GET_MAGIC_LINK)

  const handleSubmit = (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault()
    if (loading) return

    loaderAlert({ html: 'Getting magic link...' })

    const form = ev.currentTarget
    const emailInput = form.elements.namedItem('email') as HTMLInputElement

    getLink({ variables: { event, email: emailInput.value } })
      .then(response => {
        const error = response?.error?.message
        if (error) {
          simpleAlert({ html: error, icon: 'warning' })
          return
        }

        const message = response?.data?.getMagicLink?.message
        simpleAlert({
          html: message,
          icon: 'success',
        })
        closeModal()
      })
      .catch(err => {
        simpleAlert({
          html: err?.message || 'An error occurred while getting link',
          icon: 'error',
        })
      })
      .finally(() => {
        emailInput.value = ''
      })
  }

  if (!event) return null
  return (
    <Modal centered show={open} onHide={closeModal} className="modal-rounded-0">
      <Modal.Body className="text-center pt-4">
        <SiteLogo width="47px" height="30px" color={salmon} />
        <h3 className="mt-2 text-primary">Invited?</h3>
        <form onSubmit={handleSubmit} className="px-2 px-lg-5 pb-1 pb-lg-3">
          <p className="fz-14 py-2">
            Please give us your invite email address and we'll send you a magic
            link that you can log in with
          </p>
          <FormControl
            required
            autoFocus
            id="email"
            type="email"
            name="email"
            className="mb-3"
            autoComplete="email"
            placeholder="Email address"
          />
          <Button className="d-block px-5 mx-auto mt-3" type="submit">
            Get Magic Link
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  )
}
